import React from 'react';

// Imports
import Nav from './nav/nav';
import Header from './header/header';
import Footer from './footer/footer';
import { Json } from '../../config/menu';
import { Base } from '../../config/base';
//End 

const Layout = (props) => {
    console.log(Base);
    return (
        <div id="page-container"
            className={'enable-page-overlay side-scroll page-header-fixed main-content-narrow ' +
                (Base.darkMenu === true ? 'sidebar-dark ' : '') +
                (Base.darkTopBar === true ? 'page-header-dark ' : '') +
                (props.showSideOverlay === true ? 'side-overlay-o ' : '') +
                (Base.fixedNav ? 'sidebar-o ' : '')
            }>
            <Nav menu={Json} info={Base} />
            <Header info={Base} />
            <main id="main-container">
                <div className="">
                    {props.children}
                </div>
            </main>
            {!props.hideFooter ? 
            <Footer info={Base} menu={Json} />
            : ""}

        </div>
    );
}

export default Layout;